var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleProgress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3101_4395)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 19.5C15.4706 19.5 19.5 15.4707 19.5 10.5C19.5 5.52944 15.4707 1.49998 10.5 1.49998C5.52944 1.49998 1.49998 5.52944 1.49998 10.5C1.49998 15.4706 5.52944 19.5 10.5 19.5ZM10.5 20.5C16.0228 20.5 20.5 16.0228 20.5 10.5C20.5 4.97711 16.0228 0.5 10.5 0.5C4.97711 0.5 0.5 4.97711 0.5 10.5C0.5 16.0228 4.97711 20.5 10.5 20.5Z",
    fill: "#1A0063"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 10.5C14.5 10.776 14.2761 11 14.0001 11H6.99999C6.72382 11 6.5 10.776 6.5 10.5C6.5 10.2239 6.72382 10 6.99999 10H13.9999C14.2761 10 14.5 10.2239 14.5 10.5Z",
    fill: "#1A0063"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 14.5C10.2239 14.5 10 14.2761 10 14.0001V6.99999C10 6.72382 10.2239 6.5 10.5 6.5C10.776 6.5 11 6.72382 11 6.99999V13.9999C11 14.2761 10.776 14.5 10.5 14.5Z",
    fill: "#1A0063"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3101_4395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleProgress);
export default __webpack_public_path__ + "static/media/circle-progress.eaa2da5a601aab732ab38b8dc75691e7.svg";
export { ForwardRef as ReactComponent };